import { configureStore } from '@reduxjs/toolkit'
import applicationReducer from './application.slice'
import projectReducer from '../../modules/Portafolio/Project/Project.slice'
import themeReducer from '../../components/Theme/theme.slice'

export const store = configureStore({
  reducer: {
    applications: applicationReducer,
    projects: projectReducer,
    theme: themeReducer,
  },
  devTools: true
})
